import { render, staticRenderFns } from "./VisualizacionOyentesIndustria.vue?vue&type=template&id=ef2f5fbe&scoped=true&"
import script from "./VisualizacionOyentesIndustria.vue?vue&type=script&lang=js&"
export * from "./VisualizacionOyentesIndustria.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionOyentesIndustria.vue?vue&type=style&index=0&id=ef2f5fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2f5fbe",
  null
  
)

export default component.exports